module.exports = __webpack_public_path__ + "img/1.1dc23763.png";